import { getPath } from "../../utils";

const initialState = {
  carriersList: [],
  carrierModels: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_CARRIERS_LIST":
      return setCarriersList(state, action);
    case "SET_CARRIER_MODELS":
      return setCarrierModels(state, action);
    default:
      return state;
  }
}

const setCarrierModels = (state, action) => {
  return {
    ...state,
    carrierModels: getPath(action.payload, "vehicle_models", []),
  };
};

const setCarriersList = (state, action) => {
  return {
    ...state,
    carriersList: getPath(action.payload, "carriers", []),
  };
};
